import bffAPI from 'services/api/bff';

export async function getConfigs() {
  return bffAPI.get(`/business-services/configs`).then(({ data }) => data);
}
